import Utility from "../../../Utility";

async function getSortedCameras() {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const cameras = devices.filter(device => device.kind === 'videoinput');
    let frontCameras, backCameras;

    if (Utility.isAndroid()) {
        cameras.sort((a, b) => {
            const matchA = a.label.match(/camera2\s+(\d+)/);
            const matchB = b.label.match(/camera2\s+(\d+)/);

            if (matchA && matchB) {
                return parseInt(matchA[1]) - parseInt(matchB[1]);
            }

            if (matchA) {
                return -1;
            }
            if (matchB) {
                return 1;
            }
            return a.label.localeCompare(b.label);
        });

        const isCameraFront = (camera) => {
            const label = camera.label.toLowerCase();

            if (label.includes('facing front') || label.includes('front-facing')) {
                return true;
            }

            if (!label.includes('back') && !label.includes('rear')) {
                if (label.includes('front') || label.includes('user') || label.includes('selfie')) {
                    return true;
                }
            }

            if (!label.includes('facing')) {
                return /camera\s*0/i.test(camera.label);
            }

            return false;
        };

        const isCameraBack = (camera) => {
            const label = camera.label.toLowerCase();

            if (label.includes('facing back') || label.includes('back-facing')) {
                return true;
            }

            if (!label.includes('front')) {
                if (label.includes('back') || label.includes('rear') || label.includes('environment')) {
                    return true;
                }
            }

            if (!label.includes('facing')) {
                return /camera\s*1/i.test(camera.label);
            }

            return false;
        };

        frontCameras = cameras.filter(isCameraFront);
        backCameras = cameras.filter(isCameraBack);
    }
    return {cameras, frontCameras, backCameras};
}

export { getSortedCameras }